
import { AuthService } from "@/services";
import AppCalendarWidget from "../../components/calendar/CalendarWidget.vue";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	computed: {
		isAllowed():boolean{
			return AuthService.hasModule(71);
		},
		title():TranslateResult{
			return this.$ct("calendar");
		}
	},
	components: {
		AppCalendarWidget
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
